import * as THREE from 'three';

// Loads the mountain lake tools/build-moonlake.mjs prepared - the photo and
// its lossless masks (R sky, G mountains, B water) - once, at startup, for
// visualizers/moonlake.js. Same preload/get shape as fairground-assets.js,
// and the same rule: the preload is a WIRING POINT every entry point must
// call (main, main-radio, main-embedded, play-boot, player-boot,
// landing-boot, demo-boot, the capture harness). Resolves to null when the
// photo or the masks are missing: the entry points then withdraw Moonlake
// (disableVisualization) - without its picture it is unavailable.
const MANIFEST_URL = 'textures/moonlake.json';

let _assets = null;
let _promise = null;

function loadTexture(url, configure) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) { configure(t); t.needsUpdate = true; resolve(t); }, undefined, function () {
      reject(new Error(url + ' failed to load'));
    });
  });
}

export function preloadMoonlake() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('moonlake.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (manifest) {
      if (!manifest.webp || !manifest.png || !manifest.notch || !manifest.skyline) throw new Error('moonlake.json incomplete (run tools/build-moonlake.mjs)');
      return Promise.all([
        loadTexture('textures/' + manifest.webp, function (t) {
          t.colorSpace = THREE.SRGBColorSpace;
          t.generateMipmaps = false;
          t.minFilter = THREE.LinearFilter;
          t.magFilter = THREE.LinearFilter;
          t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
        }),
        // the masks are data: no colour space; linear filtering keeps the
        // build's softened edge
        loadTexture('textures/' + manifest.png, function (t) {
          t.colorSpace = THREE.NoColorSpace;
          t.generateMipmaps = false;
          t.minFilter = THREE.LinearFilter;
          t.magFilter = THREE.LinearFilter;
          t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
        })
      ]).then(function (parts) {
        _assets = { manifest: manifest, photo: parts[0], mask: parts[1] };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] moonlake assets unavailable, Moonlake will not be offered', err);
      _assets = null;
      return null;
    });
  return _promise;
}

export function getMoonlake() {
  return _assets;
}
